/* Component in the TalentPage component to display the Callsheet 
   Cast items 
 * Contains the CallCastInfo component to display 
   the extra cast info 
 * Contains the CallCastInfoMob component to display 
   the extra cast info in mobile */
import React, { useState } from "react";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import styles from "../../../styles/Callsheets.module.css";
import { PostDropdown } from "../../../components/PostDropdown";
import { axiosInstance, axiosReq } from "../../../api/axiosDefaults";
import { CLIENT_PROGRAM_HOSTNAME } from "../../../utils/config";
import useHostName from "../../../hooks/useHostName";
import toast from "react-hot-toast";
import CallsheetEditCrew2 from "../CallsheetEditCrew2";

const CrewCallsAdd2 = (props) => {
  const host = useHostName();
  const [showEdit, setShowEdit] = useState(false);

  const {
    handleMount,
    id,
    day_id,
    name,
    position,
    phone,
    email,
    call,
  } = props;

  const [crewNew, setCrewNew] = useState({
    id1: id,
    day_id1: day_id,
    name1: name,
    position1: position,
    phone1: phone,
    email1: email,
    call1: call,
  });

  const { name1, 
    position1, 
    call1, } =
    crewNew;

  const handleEdit = () => {
    setShowEdit((showEdit) => !showEdit);
  };

  /* 222222222 NEEDS NEW URL REQUEST  2222222222222222222222222222222222 */
  const handleDelete = async () => {
    try {
      if (host === CLIENT_PROGRAM_HOSTNAME) {
        await axiosReq.delete(`castcallsnew/${id}/`);
        toast.success(`Crew Deleted`);
        handleMount();
      } else {
        await axiosInstance.delete(
          `${localStorage.getItem("projectSlug")}/castcallsnew/${id}/`,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
            },
            withCredentials: true,
          }
        );
        handleMount();
        toast.success(`Crew Deleted`);
      }
    } catch (err) { }
  };

  return (
    <div className={` ${styles.Bold}`}>
    <div className="d-none d-sm-block">
    <Row className='text-center mx-0 mb-0 pb-0' >
    <Col xs={12} className={`${styles.RightPanel} mx-0 px-0`}>
      <Row className={`mt-1 mx-0 d-flex align-items-center`} >
        <Col className={`mx-0 px-0 ${styles.Borderl}`} xs={12} sm={5} >
          <p className={`${styles.BoldScene} my-0 py-0 `}>
          {position1} </p> 
        </Col>
        <Col className={`mx-0 px-0 ${styles.Borderm}`} xs={8} sm={4} >
          <p className={`my-0 py-0 `}>
            {name1} 
          </p>
        </Col>
        <Col className={`mx-0 px-0 text-center ${styles.Border}`} xs={3} sm={2} >
          <p className={`my-0 py-0 `}>{call1}</p>
        </Col>
        <Col className={`mx-0 px-0 d-flex align-items-center justify-content-center `} xs={1} sm={1}>
        <PostDropdown
                handleEdit={handleEdit}
                handleDelete={handleDelete}
            />
        </Col>
      </Row>
      <hr className={`mt-1 mb-1 ${styles.BreakCrew}`} />
      </Col>
    </Row>
    </div>
    {/* MOBILE */}
    <div className="d-block d-sm-none">
    <Row className='text-center mx-0 mb-0 pb-0' >
    <Col xs={12} className={`${styles.RightPanel} mx-0 px-0`}>
      <Row className={`mt-1 mx-0 d-flex align-items-center`} >
        <Col className={`mx-0 px-0 ${styles.Borderl}`} xs={8} >
          <p className={`${styles.BoldScene} my-0 py-0`}>
          {position1} </p> 
          <p className={`my-0 py-0 `}>
            {name1} 
          </p>
        </Col>
        <Col className={`mx-0 px-0 text-center ${styles.Border}`} xs={3} >
          <p className={`my-0 py-0 `}>{call1}</p>
        </Col>
        <Col className={`mx-0 px-0 d-flex align-items-center justify-content-center `} xs={1} sm={1}>
        <PostDropdown
                handleEdit={handleEdit}
                handleDelete={handleDelete}
            />
        </Col>
      </Row>
      <hr className={`mt-0 mb-0 ${styles.BreakCrew2}`} />
      </Col>
    </Row>
    </div>
    {/* edit */}
    <Row>
        <Col>
            {!showEdit ?("") : (                       
            <CallsheetEditCrew2
            setCrewNew={setCrewNew}
            setShowEdit={setShowEdit}
            {...crewNew}/> 
            ) }
        </Col>
    </Row>  
    </div>
  );
};

export default CrewCallsAdd2